import { render, staticRenderFns } from "./SearchResultListPublishing.vue?vue&type=template&id=be205b38&scoped=true&"
import script from "./SearchResultListPublishing.vue?vue&type=script&lang=js&"
export * from "./SearchResultListPublishing.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultListPublishing.vue?vue&type=style&index=0&id=be205b38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be205b38",
  null
  
)

export default component.exports